import { useRef, useState, useEffect, useCallback } from "react";
import ReactPlayer from "react-player";
import { DEDALO_DOMAIN } from "@/api/dedaloApi";
import { useTranslation } from "react-i18next";
import Layout from "@/components/Layout/Layout";


export default function Video({ videoUrl, subtitlesUrl, title, close }) {
    const { i18n, t } = useTranslation();
    const playerRef = useRef(null);
    const videoContentRef = useRef(null);
    const [playing, setPlaying] = useState(true);
    const [muted, setMuted] = useState(false);
    const [volume, setVolume] = useState(1);

    const video = videoUrl ? DEDALO_DOMAIN + videoUrl : '';
    const subtitles = subtitlesUrl ? DEDALO_DOMAIN + subtitlesUrl : '';

    useEffect(() => {
        if (videoContentRef.current) {
            videoContentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [])

    const togglePlay = useCallback(() => setPlaying(p => !p), []);
    const toggleMute = useCallback(() => {
        setMuted(m => !m);
        if (muted) setVolume(1);
        else setVolume(0);
    }, [muted]);

    return (
        <Layout>
            <div className="audiovisual bottom-shadow is-flex is-flex-direction-column">
                <button className="close-btn bg-white" aria-label="Cerrar" onClick={close}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48"><g fill="none" fillRule="evenodd" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M36 12 12 36M12 12l24 24"/></g></svg>
                </button>
                <div className="video-content" ref={videoContentRef}>
                    <ReactPlayer
                        ref={playerRef}
                        src={video}
                        playing={playing}
                        controls={false}
                        width="100%"
                        height="100%"
                        volume={volume}
                        muted={muted}
                        config={{
                            file: {
                                attributes: { crossOrigin: 'anonymous' },
                                tracks: subtitles ? [
                                    {
                                        kind: 'subtitles',
                                        src: subtitles,
                                        srcLang: i18n.language,
                                        default: true
                                    }
                                ] : []
                            }
                        }}
                    />
                </div>
                <div className="panel-container">
                    {title && (
                        <div className="video-info has-background-white flow--xs">
                            <h1 className="has-text-weight-semibold is-size-2">{title}</h1>
                        </div>
                    )}
                    <div className="video-controls has-background-light">
                        <button type="button" onClick={togglePlay}>
                            <div className={"player-icon play mx-auto" + (playing ? " pause" : "")}>
                                <span className="is-sr-only">{playing ? t('Pausar') : t('Reproducir')}</span>
                            </div>
                        </button>
                        <button type="button" onClick={toggleMute}>
                            <div className={"player-icon volume mx-auto" + (muted ? " mute" : "")}>
                                <span className="is-sr-only">{t('Volumen')}</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </Layout>
    )
}